module.exports = __webpack_public_path__ + "static/media/place.011676c0.svg";